import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "mrp_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: BASE });
client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  get: (p, c) => client.get(p, c).then((r) => r.data),
  post: (p, b, c) => client.post(p, b, c).then((r) => r.data),
  put: (p, b, c) => client.put(p, b, c).then((r) => r.data),
  patch: (p, b, c) => client.patch(p, b, c).then((r) => r.data),
  delete: (p, c) => client.delete(p, c).then((r) => r.data),
};

export function fileUrl(path) {
  if (!path) return "";
  return `${BASE}/files/${path}?token=${encodeURIComponent(getToken())}`;
}

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return e?.message || "Something went wrong";
}
